if (!customElements.get('buy-now-button')) {
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-buy-now]');
    if (!button || button.getAttribute('aria-disabled') === 'true') return;

    const form = document.getElementById(button.dataset.formId);
    if (!form) return;

    const errorWrapper = form.querySelector('.product-form__error-message-wrapper');
    const errorText = form.querySelector('.product-form__error-message');
    if (errorWrapper) errorWrapper.hidden = true;

    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');

    const cartAddUrl =
      (window.routes && window.routes.cart_add_url) || '/cart/add';

    fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/javascript',
      },
      body: new FormData(form),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          if (errorText) errorText.textContent = response.description || response.message || '';
          if (errorWrapper) errorWrapper.hidden = false;
          button.removeAttribute('aria-disabled');
          button.classList.remove('loading');
          return;
        }
        window.location.href = '/checkout';
      })
      .catch(() => {
        button.removeAttribute('aria-disabled');
        button.classList.remove('loading');
      });
  });

  // Marks the script as loaded so it only attaches one click listener.
  customElements.define('buy-now-button', class extends HTMLElement {});
}
